var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline"},[(_vm.params.lastLocationTime)?_c('span',{staticClass:"last-seen-text text-ellipsis"},[_vm._v(_vm._s(_vm._f("moment")(_vm.params.lastLocationTime,'MM/DD/YYYY hh:mm A')))]):_c('span',{staticClass:"last-seen-text text-ellipsis"},[_vm._v("--")])])
}
var staticRenderFns = []

export { render, staticRenderFns }